import styled from "styled-components";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { riotStyle } from "./riotStyle";
import { riotProductSkin } from "./riot-product";
import { SkinId } from "../../../skins/types";
import { leagueClientStyle } from "./league-client";
import { projectLStyle } from "./project-l";
export const themed = (component) => styled(component) `
  display: inline-block;
  mask-repeat: no-repeat;

  ${mixinSkins({
    [SkinId.Riot]: riotStyle,
    [SkinId.RiotProduct]: riotProductSkin,
    [SkinId.LeagueClient]: leagueClientStyle,
    [SkinId.RiotProductLion]: projectLStyle,
})}
`;
//# sourceMappingURL=index.js.map